export function isUkSite() {
  return window.locale === 'en-GB';
}

export function usOrUkUrlFor(path) {
  if (window.locale === 'en-GB') {
    return `/uk${path}`.replace(/\/+$/, '');
  } else {
    return path;
  }
}
